import { Button, Flex, Popconfirm, Typography } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import './AttachedFiles.css';

const AttachedFiles = ({ files, onRemoveFile, isChatMode = false }) => {
    if (!files || files.length === 0) {
        return null;
    }

    const containerClass = isChatMode 
        ? 'attached-files attached-files--chat-mode' 
        : 'attached-files';

    const fileItemClass = isChatMode
        ? 'attached-files__item attached-files__item--chat-mode'
        : 'attached-files__item';

    const textClass = isChatMode
        ? 'attached-files__name attached-files__name--chat-mode'
        : 'attached-files__name';

    return (
        <div className={containerClass}>
            {files.map((file, index) => (
                <Flex 
                    gap={8} 
                    align='center' 
                    justify='space-between' 
                    key={file.uid || index} 
                    className={fileItemClass}
                >
                    {isChatMode ? (
                        <Flex gap={8} align='center' className="attached-files__content">
                            <PaperClipOutlined className="attached-files__icon" />
                            <Typography.Text className={textClass}>
                                {file.name}
                            </Typography.Text>
                        </Flex>
                    ) : (
                        <Typography.Text className={textClass}>
                            {file.name}
                        </Typography.Text>
                    )}
                    <Popconfirm
                        title="Вы уверены, что хотите открепить этот файл?"
                        placement='bottomRight'
                        okText="Да"
                        cancelText="Нет"
                        onConfirm={() => onRemoveFile(file)}
                    >
                        <Button
                            type="text"
                            size="small"
                            className="attached-files__remove-button"
                            icon={<span style={{ fontSize: 16 }}>×</span>}
                        />
                    </Popconfirm>
                </Flex>
            ))}
        </div>
    );
};

export default AttachedFiles;
